import React, { useRef, useState } from 'react'
import { Upload, X } from 'lucide-react'
import styled from 'styled-components'

const UploadContainer = styled.div`
  width: 100%;
  height: 200px;
`

const UploadArea = styled.div<{ isDragActive?: boolean; hasFile?: boolean }>`
  border: 2px dashed ${props => props.isDragActive ? '#0090D3' : '#E5E7EB'};
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  background: ${props => props.isDragActive ? '#E6F4FB' : '#FFF'};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: ${props => props.hasFile ? 'space-between' : 'center'};
  flex-direction: ${props => props.hasFile ? 'row' : 'column'};

  &:hover {
    border-color: #0090D3;
    background: #E6F4FB;
  }
`

const InputTip = styled.span`
  color: #6B7280;
`

const HiddenInput = styled.input`
  display: none;
`

const UploadIcon = styled.div`
color: #6B7280;
margin-bottom: ${(props:{hasFile?: boolean}) => props.hasFile ? '0' : '12px'};

svg {
  width: ${props => props.hasFile ? '24px' : '40px'};
  height: ${props => props.hasFile ? '24px' : '40px'};
  margin: 0 auto;
}
`

const UploadContent = styled.div<{ hasFile?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${props => props.hasFile ? '12px' : '0'};
  flex-direction: ${props => props.hasFile ? 'row' : 'column'};
`

const UploadText = styled.p<{ hasFile?: boolean }>`
color: #374151;
margin: 0;
font-size: 0.875rem;
${props => props.hasFile && `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`}
`

const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #EF4444;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #DC2626;
  }
`

interface InputFilesProps {
  handleAddImage: (file: File) => void
  onOpenSourceModal?: () => void
}

const InputFiles = ({ handleAddImage, onOpenSourceModal }: InputFilesProps) => {
  const [ isDragActive, setIsDragActive ] = useState(false)
  const fileInputRef = useRef<HTMLInputElement>(null)
  const test = 2

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragActive(false)
    
    if (e.dataTransfer.files) {
      Array.from(e.dataTransfer.files).forEach(file => handleAddImage(file))
    }
  }

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragActive(true)
  }

  const handleDragLeave = () => {
    setIsDragActive(false)
  }

  const handleClick = () => {
    if (onOpenSourceModal) {
      onOpenSourceModal()
    } else {
      fileInputRef.current?.click()
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      Array.from(e.target.files).forEach(file => handleAddImage(file))
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  const handleRemove = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }
  
  return(
    <UploadContainer>
      <UploadArea
        isDragActive={isDragActive}
        hasFile={false}
        onClick={handleClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <HiddenInput
          ref={fileInputRef}
          type="file"
          multiple
          accept=".jpg, .jpeg, .png, image/jpeg, image/png"
          onChange={handleChange}
        />
        
        {test < 2 ? (
          <>
            <UploadContent hasFile>
              <UploadIcon hasFile>
                <Upload />
              </UploadIcon>
              <UploadText hasFile>
                nome do arquivo
              </UploadText>
            </UploadContent>
            <RemoveButton onClick={handleRemove}>
              <X size={16} />
            </RemoveButton>
          </>
        ) : (
          <UploadContent>
            <UploadIcon>
              <Upload />
            </UploadIcon>
            <InputTip style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px'}}>Arraste suas imagens aqui ou clique para selecionar</InputTip>
            <InputTip style={{fontSize: '14px'}}>Formatos suportados: JPEG, PNG • Máximo 10MB por arquivo</InputTip>
          </UploadContent>
        )}
      </UploadArea>
    </UploadContainer>
  )
}

export default InputFiles